// Strip unwanted properties from an object
export function stripProperties<T extends Record<string, any>>(obj: T, propertiesToStrip: (keyof T)[]): Partial<T> {
  const result = { ...obj };
  propertiesToStrip.forEach(property => delete result[property]);

  return result;
}

// Remove a key from an object and return a new object without that key
export function stripKeyFromObject<T, K extends keyof T>(obj: T, key: K): Omit<T, K> {
  const {[key]: _, ...rest} = obj;

  return rest;
}